export const theme = {
  primary: "#0b0c10",
  textColor: "#ffff",
};
